import { render, staticRenderFns } from "./ContactsList.vue?vue&type=template&id=161d7b0e&scoped=true&lang=pug&"
import script from "./ContactsList.vue?vue&type=script&lang=js&"
export * from "./ContactsList.vue?vue&type=script&lang=js&"
import style0 from "./ContactsList.vue?vue&type=style&index=0&id=161d7b0e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d7b0e",
  null
  
)

export default component.exports